import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { CandidatePool } from '../candidate-pool/candidate-pool.interface';
import { Candidate } from './candidate.interface';

export interface CandidateState {
   candidates: Array<Candidate>;
   candidate?: Candidate;
}

const CandidateStore: Module<CandidateState, StoreState> = {
   namespaced: true,
   state: {
      candidates: [],
   },

   getters: {},

   mutations: {
      addCandidatePoolToCandidate(state, candidate_pool: CandidatePool) {
         if (state.candidate) {
            const formatted_candidate_pool = {
               id: candidate_pool.pool?.id,
               name: candidate_pool.pool?.name,
               description: candidate_pool.pool?.description,
               candidate_pool: {
                  id: candidate_pool.id,
               },
               candidate_pools: [{ id: candidate_pool.id, tags: [] }],
            } as unknown as CandidatePool;
            state.candidate.pools?.push(formatted_candidate_pool);
         }
      },
      removeCandidatePoolFromCandidate(state, candidate_pool_id: number) {
         if (state.candidate && state.candidate.pools) {
            const index = state.candidate.pools.findIndex((p) => p.candidate_pool.id === candidate_pool_id);
            state.candidate.pools.splice(index, 1);
         }
      },
      addOrUpdateCandidatesInPage(state, candidates: Array<Candidate>) {
         candidates.forEach((candidate) => {
            const INDEX = state.candidates.findIndex((c) => c.id == candidate.id);
            if (INDEX == -1) state.candidates.unshift(candidate);
            else state.candidates[INDEX] = candidate;
         });
      },
   },

   actions: {},
};

export default CandidateStore;
